module.exports = __webpack_public_path__ + "img/winerackdog26.90c55a84.jpg";